import script from "./TopOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./TopOffer.vue?vue&type=script&setup=true&lang=js"

import "./TopOffer.vue?vue&type=style&index=0&id=79cd54fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79cd54fc"]])

export default __exports__